var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHouseWithBushes = function SvgHouseWithBushes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 364 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#house-with-bushes_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.521 7.163h.102l67.439 107.73h-22.85l-50.848-96.775 6.157-10.955Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.331 111.373V228.6H57.825V115.884c.697 0 115.858-1.282 140.426-1.547 2.409-.034 3.498-.047 4.574-.047l2.301-3.385L275.521 7.163l56.559 103.749.251.468v-.007Z",
    fill: "#D5EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.331 111.373v3.324h-134.08v-3.792H332.08l.251.468Z",
    fill: "#EDF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.419 114.29v114.309H57.825V115.884c.764 0 136.197-1.499 144.594-1.594Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.353 0h-25.956v24.162h25.956V0Z",
    fill: "#566C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.346 10.623v7.176l-25.949 1.153v-3.181l25.949-5.148Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.521 7.163-6.008 8.947-.541.814-5.494 8.208-.528.793-5.508 8.201-.534.8-5.488 8.201-.548.8-5.494 8.188-.528.814-5.494 8.187-.528.794-5.487 8.187-.535.8-5.487 8.188-.528.794-5.494 8.173-.528.794-5.481 8.194-.541.794-5.48 8.173-.528.794-5.65 8.425-156.53 2.916 4.08-6.647.48-.794 4.852-7.909.5-.793 4.852-7.923.5-.794 4.859-7.93.48-.793 4.872-7.923.48-.793 4.872-7.93.48-.793 4.872-7.923.494-.814 4.858-7.923.494-.807 4.872-7.93.5-.807 4.865-7.923.487-.814 4.872-7.936.494-.8 4.128-6.722 166.719-9.558Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.513 16.11-.541.814-164.792 7.32.494-.801 164.839-7.333ZM263.478 25.132l-.528.793-164.129 7.068.487-.814 164.17-7.047ZM257.442 34.126l-.534.8-163.452 6.797.5-.807 163.486-6.79ZM251.42 43.127l-.548.8L88.09 50.46l.494-.807 162.836-6.526ZM245.378 52.115l-.528.814-162.112 6.268.494-.814 162.146-6.268ZM239.356 61.117l-.528.793-161.442 6.003.48-.793 161.49-6.004ZM233.341 70.097l-.535.8-160.772 5.74.48-.794 160.827-5.746ZM227.319 79.085l-.528.794-160.11 5.474.481-.794 160.157-5.474ZM221.297 88.052l-.528.794-159.446 5.23.5-.794 159.474-5.23ZM215.288 97.04l-.541.794-158.776 4.958.5-.793 158.817-4.959ZM209.267 106.007l-.528.794-158.1 4.694.48-.794 158.148-4.694Z",
    fill: "#566C77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.132 183.493H57.982v45.069h144.15v-45.069Z",
    fill: "#7B9FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.593 183.493H202.132v45.069h130.461v-45.069Z",
    fill: "#C2DEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.508 183.593h-1.556v45h1.556v-45ZM71.438 183.593h-1.556v45h1.556v-45ZM79.389 183.593h-1.556v45h1.556v-45ZM87.339 183.593h-1.556v45h1.556v-45ZM95.276 183.593H93.72v45h1.556v-45ZM103.226 183.593h-1.556v45h1.556v-45ZM111.163 183.593h-1.556v45h1.556v-45ZM119.113 183.593h-1.556v45h1.556v-45ZM127.064 183.593h-1.557v45h1.557v-45ZM135 183.593h-1.556v45H135v-45ZM142.951 183.593h-1.557v45h1.557v-45ZM150.901 183.593h-1.556v45h1.556v-45ZM158.838 183.593h-1.556v45h1.556v-45ZM166.788 183.593h-1.556v45h1.556v-45ZM174.738 183.593h-1.556v45h1.556v-45ZM182.675 183.593h-1.556v45h1.556v-45ZM190.626 183.593h-1.557v45h1.557v-45ZM198.562 183.593h-1.556v45h1.556v-45Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.686 183.593h-1.556v45h1.556v-45ZM217.636 183.593h-1.556v45h1.556v-45ZM225.587 183.593h-1.557v45h1.557v-45ZM233.523 183.593h-1.556v45h1.556v-45ZM241.474 183.593h-1.556v45h1.556v-45ZM249.424 183.593h-1.556v45h1.556v-45ZM257.361 183.593h-1.556v45h1.556v-45ZM265.311 183.593h-1.556v45h1.556v-45ZM273.248 183.593h-1.556v45h1.556v-45ZM281.198 183.593h-1.556v45h1.556v-45ZM289.149 183.593h-1.557v45h1.557v-45ZM297.085 183.593h-1.556v45h1.556v-45ZM305.036 183.593h-1.557v45h1.557v-45ZM312.986 183.593h-1.556v45h1.556v-45ZM320.923 183.593h-1.556v45h1.556v-45ZM328.873 183.593h-1.556v45h1.556v-45Z",
    fill: "#D5EAFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.971 130.495h-27.742v44.341h27.742v-44.341Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.016 132.747v1.77l10.216 26.407 12.308 11.518h1.638v-39.695h-24.162Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.452 134.49h-22.436v37.952h22.436V134.49Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.646 149.942h-26.618v1.791h26.618v-1.791ZM306.545 130.495h-27.742v44.341h27.742v-44.341Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.589 132.747v1.77l10.211 26.407 12.314 11.518h1.638v-39.695h-24.163Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.026 134.49h-22.437v37.952h22.437V134.49Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.213 149.942h-26.618v1.791h26.618v-1.791ZM289.027 75.402c0 9.68-7.497 17.52-16.753 17.52-22.194-.847-22.187-34.2 0-35.048 9.249 0 16.753 7.848 16.753 17.52v.008Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.004 75.402c0 4.633-1.956 8.797-5.055 11.62-14.493 12.25-32.241-7.455-20.786-21.748 8.837-10.73 25.949-3.913 25.841 10.121v.007Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.664 76.792a15.88 15.88 0 0 1-3.715 10.236c-14.493 12.25-32.241-7.455-20.786-21.747 9.331-8.845 24.684-1.499 24.501 11.511Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.182 58.539h-1.78v33.319h1.78v-33.32Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.337 74.404h-31.856v1.86h31.856v-1.86ZM100.127 130.488H72.386v44.341h27.741v-44.341Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.34 132.747v1.75l-12.984 24.982-9.54 12.963H74.18v-39.695H98.34Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.34 134.49H75.905v37.952h22.437V134.49Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.336 149.942H72.717v1.791h26.619v-1.791ZM188.244 130.488h-27.742v44.341h27.742v-44.341Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.458 132.747v1.75l-12.985 24.982-9.547 12.963h-1.631v-39.695h24.163Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.458 134.49h-22.437v37.952h22.437V134.49Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.452 149.942h-26.618v1.791h26.618v-1.791Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.651 138.587H108.01v90.006h42.641v-90.006Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.786 141.022h-40.523v85.536h40.523v-85.536Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.831 224.211h-36.619a.388.388 0 0 1-.386-.394v-80.448c0-.217.176-.393.386-.393h36.619c.216 0 .385.176.385.393v80.448a.392.392 0 0 1-.385.394Zm-36.234-.78h35.841v-79.669h-35.841v79.669Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.881 178.411h-9.662a.387.387 0 0 1-.386-.394v-31.724c0-.217.176-.394.386-.394h9.669c.216 0 .385.177.385.394v31.724a.392.392 0 0 1-.385.394h-.007Zm-9.283-.787h8.89v-30.945h-8.89v30.945ZM144.094 178.411h-9.669a.387.387 0 0 1-.385-.394v-31.724c0-.217.175-.394.385-.394h9.669c.217 0 .386.177.386.394v31.724a.392.392 0 0 1-.386.394Zm-9.276-.787h8.89v-30.945h-8.89v30.945ZM126.881 218.364h-9.662a.388.388 0 0 1-.386-.394v-31.731c0-.217.176-.394.386-.394h9.669c.216 0 .385.177.385.394v31.731a.392.392 0 0 1-.385.394h-.007Zm-9.283-.78h8.89v-30.952h-8.89v30.952ZM144.094 218.364h-9.669a.388.388 0 0 1-.385-.394v-31.731c0-.217.175-.394.385-.394h9.669c.217 0 .386.177.386.394v31.731a.393.393 0 0 1-.386.394Zm-9.276-.78h8.89v-30.952h-8.89v30.952Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.083 226.205H45.903v5.576h293.18v-5.576Z",
    fill: "#566C77"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#house-with-bushes_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364 235h-92.611c.886-5.107 3.331-9.922 7.463-12.83 5.655-4.002 14.659-3.03 18.165 3.05 2.712-11.678 12.057-21.487 23.376-24.555 11.347-3.096 24.197.68 32.205 9.441 6.199 6.759 9.317 15.765 11.393 24.894H364Z",
    fill: "#249241"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#house-with-bushes_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.61 235H0c.886-5.107 3.33-9.922 7.463-12.83 5.655-4.002 14.659-3.03 18.164 3.05 2.713-11.678 12.058-21.487 23.377-24.555 11.346-3.096 24.197.68 32.204 9.441 6.2 6.759 9.318 15.765 11.393 24.894h.01Z",
    fill: "#249241"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "house-with-bushes_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(45.903)",
    d: "M0 0h297.159v231.781H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "house-with-bushes_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(271.389 199.589)",
    d: "M0 0h92.611v35.411H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "house-with-bushes_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 199.589)",
    d: "M0 0h92.611v35.411H0z"
  })))));
};
export default SvgHouseWithBushes;